import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Snackbar, Alert, Typography } from '@mui/material'

import apiUtils from '../../utils/api'
import permissions from '../../utils/permissions'

const stateSelector = state => ({
  staffStore: state.staff,
  loggedInUser: state.user.loggedIn.user,
  selectedFirm: state.firm.selected,
})

const FirmZipDownloadButton = () => {
  const { staffStore, loggedInUser, selectedFirm } = useSelector(stateSelector)
  const [isLoading, setIsLoading] = useState(false)
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  })

  const isOwner =
    selectedFirm &&
    permissions.isStaffOwner(staffStore, loggedInUser, selectedFirm.id)

  if (!isOwner) {
    return null
  }

  const showToast = (message, severity = 'info') => {
    setSnackbar({ open: true, message, severity })
  }

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false })
  }

  const handleDownload = async () => {
    setIsLoading(true)
    try {
      const response = await apiUtils.callAPI(
        '/api/files/download-bucket-zip',
        'POST',
        {
          recursive: true,
          maxFiles: 10000,
          firmId: selectedFirm.id,
        },
      )

      if (response.success) {
        showToast(
          'Firm files are being prepared for download. You will receive an email when ready.',
          'success',
        )
      } else {
        showToast(
          'Failed to initiate download: ' +
            (response.message || 'Unknown error'),
          'error',
        )
      }
    } catch (error) {
      console.error('Error initiating firm download:', error)
      showToast('Failed to initiate download. Please try again.', 'error')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <button
        className="yt-btn x-small info"
        onClick={handleDownload}
        disabled={isLoading}
        title="Download all firm files organized by client (Owner only)"
      >
        <i
          className="fas fa-download"
          style={{ marginRight: '5px' }}
        />
        {isLoading ? 'Preparing...' : 'Download All Files'}
      </button>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{
            width: '100%',
            alignItems: 'center',
            '& .MuiAlert-icon': {
              alignSelf: 'center',
            },
            '& .MuiAlert-message': {
              display: 'flex',
              alignItems: 'center',
            },
          }}
        >
          <Typography
            variant="body2"
            component="span"
          >
            {snackbar.message}
          </Typography>
        </Alert>
      </Snackbar>
    </>
  )
}

export default FirmZipDownloadButton
